import {ExamsSubjectsBalls} from "./exams-subjects-balls";

export class EnrollEntranceExamsInfo {
  mandatory_subjects: ExamsSubjectsBalls[] = [];
  profile_subjects: ExamsSubjectsBalls[] = [];
  count_exams_balls: number = 0;
  gpa = 0;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/enroll-entrance-exams-info.ts